module.exports = __webpack_public_path__ + "img/79fecbe.jpg";